import React from "react";
import { ChannelMode } from "../../../__generated__/api";
import Select from "../../select/Select";

const CHANNEL_MODES = {
    [ChannelMode.Threaded]: "Threaded",
    [ChannelMode.Manual]: "Manual",
};

export default function ChannelModePicker<TIsClearable extends boolean = false>({
    className,
    value,
    onChange,
    isClearable,
}: {
    isClearable?: TIsClearable,
    className?: string;
    value: ChannelMode | undefined | null;
    onChange: (value: (ChannelMode & (TIsClearable extends true ? undefined : never))) => void;
}) {
    return (
        <Select
            className={className}
            placeholder=""
            isClearable={isClearable}
            onChange={selected => onChange(selected?.value as Parameters<typeof onChange>[0])}
            options={Object.entries(CHANNEL_MODES).map(([mode, label]) => ({ value: mode, label }))}
            value={!value ? null : {
                value,
                label: CHANNEL_MODES[value as keyof typeof CHANNEL_MODES],
            }}
        />
    );
}

ChannelModePicker.defaultProps = {
    className: undefined,
    isClearable: false,
};
